import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import logo from '../assets/images/pfp.jpeg';
import Typewriter from "./Typewriter";

function Main() {
  const Titles = [
    "Software Engineer",
    "Artifacts Engineer",
    "Startup Consultant",
    "AI Infrastructure Engineer",
  ];

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={logo} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/Hamzah023" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/hamzahimrann/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Hamzah Imran</h1>
          <p><Typewriter Text={Titles} delay={300} infinite={true}/></p>

          <div className="mobile_social_icons">
            <a href="https://github.com/Hamzah023" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/hamzahimrann/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;